var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-164-Copy",
    transform: "translate(10.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5238607,48.1915822 C92.5028936,46.9328588 90.8059497,45.8841934 90.8059497,45.8841934 L87.7175164,54.120325 L92.9715203,56.1011373 C94.6445571,53.895412 95.0769749,51.0328201 94.5238607,48.1915822",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5238607,48.1915822 C92.5028936,46.9328588 90.8059497,45.8841934 90.8059497,45.8841934 L87.7175164,54.120325 L92.9715203,56.1011373 C94.6445571,53.895412 95.0769749,51.0328201 94.5238607,48.1915822 Z",
    id: "Stroke-3",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.174994,52.4380967 C101.077044,52.29094 97.4587079,50.0197602 94.5239304,48.191675 C95.0770445,51.032913 94.6443946,53.8952727 92.9713578,56.1009981 L98.2515899,58.091559 C98.2515899,58.091559 100.568263,58.312294 101.616232,56.602352 C102.664201,54.8926422 101.340487,52.6864526 101.174994,52.4380967",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.174994,52.4380967 C101.077044,52.29094 97.4587079,50.0197602 94.5239304,48.191675 C95.0770445,51.032913 94.6443946,53.8952727 92.9713578,56.1009981 L98.2515899,58.091559 C98.2515899,58.091559 100.568263,58.312294 101.616232,56.602352 C102.664201,54.8926422 101.340487,52.6864526 101.174994,52.4380967 Z",
    id: "Stroke-7",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.572433,257.735861 C209.924309,246.612998 225.290344,243.743211 236.468913,250.139188 C245.103807,255.080077 250.242221,264.978569 249.926553,275.613075 L212.844232,275.658801 C213.129725,265.436054 209.331273,259.17795 200.572433,257.735861",
    id: "Fill-9",
    fill: "#FFA076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8483559,249.066267 C33.5210832,245.038259 46.797911,251.120658 50.9343133,263.19354 C47.6553191,238.181315 62.914352,215.534739 83.6209671,210.00824 C108.191954,203.450251 137.344294,221.82441 141.515048,252.113153 C148.008511,245.045455 157.981044,242.336983 166.999613,245.187969 C176.589865,248.22 183.401779,257.000426 184.035667,267.210174 C188.334081,258.605455 198.369284,255.491025 205.365029,259.176905 C210.778723,262.029052 213.919149,268.71354 212.844255,275.658685 L11.3213153,275.658685 C10.3058414,276.212727 2.18112186,255.85265 21.8483559,249.066267 Z",
    id: "Stroke-11",
    stroke: "#1A1A1A",
    strokeWidth: 0.696324952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82574081,299.199157 L270.687946,299.199157 C274.817617,299.199157 278.165547,293.919389 278.165547,287.406197 L278.165547,287.405965 C278.165547,280.893006 274.817617,275.613238 270.687946,275.613238 L7.82574081,275.613238 C3.69606963,275.613238 0.348139265,280.893006 0.348139265,287.405965 L0.348139265,287.406197 C0.348139265,293.919389 3.69606963,299.199157 7.82574081,299.199157 Z",
    id: "Stroke-13",
    stroke: "#1A1A1A",
    strokeWidth: 0.696324952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3193114,275.613191 C81.3193114,275.613191 50.0039536,286.030445 71.4943985,286.85118 C92.9846112,287.671915 80.5747079,292.883907 88.5172224,294.869594 C96.4595048,296.85528 119.792658,298.057602 131.95258,291.003366 C144.112735,283.948897 164.712812,285.182321 164.712812,291.63911 C164.712812,298.096132 186.802329,297.095513 191.766197,291.63911 C196.730066,286.182708 215.592812,275.669826 215.592812,275.669826 L81.3193114,275.613191 Z",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3193114,275.613191 C81.3193114,275.613191 50.0039536,286.030445 71.4943985,286.85118 C92.9846112,287.671915 80.5747079,292.883907 88.5172224,294.869594 C96.4595048,296.85528 119.792658,298.057602 131.95258,291.003366 C144.112735,283.948897 164.712812,285.182321 164.712812,291.63911 C164.712812,298.096132 186.802329,297.095513 191.766197,291.63911 C196.730066,286.182708 215.592812,275.669826 215.592812,275.669826 L81.3193114,275.613191 Z",
    id: "Stroke-17",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0695783,291.639087 C97.0695783,291.639087 98.9689207,297.131002 111.433834,293.766592 C123.898747,290.402182 127.538669,286.133014 125.994453,283.71723 C124.450236,281.301679 95.9979342,284.079087 97.0695783,291.639087",
    id: "Fill-19",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.271644,287.40629 C185.271644,287.40629 195.240928,283.783544 197.061122,279.398785 C198.881083,275.014027 193.007118,279.067799 191.931528,279.398785 C190.85617,279.729772 179.68735,287.223157 185.271644,287.40629",
    id: "Fill-21",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.97993,277.643002 C109.97993,277.643002 94.7487505,282.901184 95.8129671,288.932983 C96.8774159,294.964781 104.328325,293.596039 109.752,292.582422 C115.175443,291.568573 123.386739,286.652054 123.386739,286.652054 C123.386739,286.652054 121.806081,278.018553 120.142561,277.32571 C118.479273,276.632634 115.631536,276.338321 109.97993,277.643002",
    id: "Fill-23",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.97993,277.643002 C109.97993,277.643002 94.7487505,282.901184 95.8129671,288.932983 C96.8774159,294.964781 104.328325,293.596039 109.752,292.582422 C115.175443,291.568573 123.386739,286.652054 123.386739,286.652054 C123.386739,286.652054 121.806081,278.018553 120.142561,277.32571 C118.479273,276.632634 115.631536,276.338321 109.97993,277.643002 Z",
    id: "Stroke-25",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.557957,277.545075 C118.368789,275.349331 118.368557,275.348867 118.368557,275.348867 L108.940781,275.653161 C108.940781,275.653161 108.997648,276.664456 109.423567,277.745849 C112.343257,278.974863 115.560975,278.44728 118.557957,277.545075",
    id: "Fill-27",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.423683,277.745919 C109.570143,278.117292 109.759079,278.496557 110.005346,278.846344 C110.968364,280.215087 117.760549,280.569749 118.622135,278.28882 C118.59846,278.016325 118.577338,277.769362 118.558074,277.545145 C115.560859,278.447118 112.343141,278.974932 109.423683,277.745919",
    id: "Fill-29",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.423683,277.745919 C109.570143,278.117292 109.759079,278.496557 110.005346,278.846344 C110.968364,280.215087 117.760549,280.569749 118.622135,278.28882 C118.59846,278.016325 118.577338,277.769362 118.558074,277.545145 C115.560859,278.447118 112.343141,278.974932 109.423683,277.745919 Z",
    id: "Stroke-31",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.500634,138.0133 C111.500634,138.0133 90.1359923,167.589006 91.656766,198.000998 C93.1773075,228.413222 103.821563,272.206259 107.775064,276.312023 C115.682298,279.201075 119.78783,276.312023 119.78783,276.312023 C119.78783,276.312023 109.903961,225.067845 129.215605,185.228077 L131.952627,149.037749 L111.500634,138.0133 Z",
    id: "Fill-33",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.500634,138.0133 C111.500634,138.0133 90.1359923,167.589006 91.656766,198.000998 C93.1773075,228.413222 103.821563,272.206259 107.775064,276.312023 C115.682298,279.201075 119.78783,276.312023 119.78783,276.312023 C119.78783,276.312023 109.903961,225.067845 129.215605,185.228077 L131.952627,149.037749 L111.500634,138.0133 Z",
    id: "Stroke-35",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.835551,260.1467 C187.587969,260.226081 186.520967,260.866236 186.39029,260.839776 C186.39029,260.839776 183.082979,266.656178 183.007079,266.884108 C182.959729,267.026159 183.140309,267.855482 182.877563,269.979273 C187.71911,269.410839 189.074391,264.589718 188.835551,260.1467",
    id: "Fill-37",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.513656,265.971853 C195.209594,264.755373 192.396441,261.486128 190.571838,260.49781 C190.00294,260.189571 189.400619,260.110654 188.835667,260.146631 C189.074507,264.589648 187.719226,269.41077 182.877679,269.979435 C182.717524,271.272975 182.393269,273.045818 181.752418,275.437694 C180.058956,281.757308 184.337408,287.032201 185.591954,287.032201 C186.846267,287.032201 195.81795,267.188333 195.513656,265.971853",
    id: "Fill-39",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.513656,265.971853 C195.209594,264.755373 192.396441,261.486128 190.571838,260.49781 C190.00294,260.189571 189.400619,260.110654 188.835667,260.146631 C189.074507,264.589648 187.719226,269.41077 182.877679,269.979435 C182.717524,271.272975 182.393269,273.045818 181.752418,275.437694 C180.058956,281.757308 184.337408,287.032201 185.591954,287.032201 C186.846267,287.032201 195.81795,267.188333 195.513656,265.971853 Z",
    id: "Stroke-41",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(126.731141, 134.286267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.355659574,32.3903675 C0.355659574,32.3903675 -0.708789168,44.5551644 1.2578646,53.5751257 C6.56943133,107.148279 55.7056015,135.183017 55.7056015,135.183017 C55.7056015,135.183017 61.788,133.966538 60.8755822,125.755242 C21.948,89.564913 37.4584062,35.8877756 36.5459884,24.4833656 C35.6335706,13.0787234 24.6852534,0.153539652 24.6852534,0.153539652 L4.85438298,3.29628627",
    id: "Fill-43",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.355659574,32.3903675 C0.355659574,32.3903675 -0.708789168,44.5551644 1.2578646,53.5751257 C6.56943133,107.148279 55.7056015,135.183017 55.7056015,135.183017 C55.7056015,135.183017 61.788,133.966538 60.8755822,125.755242 C21.948,89.564913 37.4584062,35.8877756 36.5459884,24.4833656 C35.6335706,13.0787234 24.6852534,0.153539652 24.6852534,0.153539652 L4.85438298,3.29628627",
    id: "Stroke-45",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.202685,142.140023 C147.641524,141.215304 151.635412,139.254917 154.837578,136.14954 L154.229455,133.831706 L111.065199,138.635884 L109.984503,140.3507 C119.03928,147.696232 132.135296,144.310236 143.202685,142.140023",
    id: "Fill-47",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.202685,142.140023 C132.135296,144.310236 119.03928,147.696232 109.984503,140.3507 L107.101253,144.925091 C107.101253,144.925091 118.875412,152.230932 133.929493,150.78629 C148.983342,149.341648 156.069609,140.843466 156.069609,140.843466 L154.837578,136.14954 C151.635412,139.254917 147.641524,141.215304 143.202685,142.140023",
    id: "Fill-49",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.202685,142.140023 C132.135296,144.310236 119.03928,147.696232 109.984503,140.3507 L107.101253,144.925091 C107.101253,144.925091 118.875412,152.230932 133.929493,150.78629 C148.983342,149.341648 156.069609,140.843466 156.069609,140.843466 L154.837578,136.14954 C151.635412,139.254917 147.641524,141.215304 143.202685,142.140023 Z",
    id: "Stroke-51",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7273424,75.035118 C74.7273424,75.035118 56.1760851,113.759605 77.9715203,128.458793 C92.062352,137.177014 113.350631,112.745988 113.350631,112.745988 L110.693919,83.0997215 C110.693919,83.0997215 92.5061431,100.885253 90.3582128,111.124015 C85.0675358,98.8577872 81.519528,86.6577099 85.7768588,77.8050986 C85.473029,75.9475358 83.0398375,74.3253308 81.4178646,73.7680387 C79.7961238,73.2102824 75.5121006,73.2713269 74.7273424,75.035118",
    id: "Fill-53",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7273424,75.035118 C74.7273424,75.035118 56.1760851,113.759605 77.9715203,128.458793 C92.062352,137.177014 113.350631,112.745988 113.350631,112.745988 L110.693919,83.0997215 C110.693919,83.0997215 92.5061431,100.885253 90.3582128,111.124015 C85.0675358,98.8577872 81.519528,86.6577099 85.7768588,77.8050986 C85.473029,75.9475358 83.0398375,74.3253308 81.4178646,73.7680387 C79.7961238,73.2102824 75.5121006,73.2713269 74.7273424,75.035118 Z",
    id: "Stroke-55",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.668565,141.637393 C109.067559,140.142151 104.835296,130.993137 105.950344,106.764975 C107.065393,82.5368124 111.323188,79.6983598 119.838545,78.4818801 C128.353903,77.2654004 148.324503,75.9474894 154.001408,91.3562321 C159.678313,106.764975 157.85371,133.324897 157.85371,133.324897 C157.85371,133.324897 136.06988,147.350971 114.668565,141.637393",
    id: "Fill-57",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.668565,141.637393 C109.067559,140.142151 104.835296,130.993137 105.950344,106.764975 C107.065393,82.5368124 111.323188,79.6983598 119.838545,78.4818801 C128.353903,77.2654004 148.324503,75.9474894 154.001408,91.3562321 C159.678313,106.764975 157.85371,133.324897 157.85371,133.324897 C157.85371,133.324897 136.06988,147.350971 114.668565,141.637393 Z",
    id: "Stroke-59",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.799149,144.121114 C126.799149,144.121114 124.775164,144.9827 125.211296,147.871985 C125.647427,150.761037 132.358143,150.355544 133.270561,149.341926 C134.182979,148.328077 134.233578,143.766221 132.408743,143.766221 C130.584139,143.766221 126.799149,144.121114 126.799149,144.121114",
    id: "Fill-61",
    fill: "#25383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.799149,144.121114 C126.799149,144.121114 124.775164,144.9827 125.211296,147.871985 C125.647427,150.761037 132.358143,150.355544 133.270561,149.341926 C134.182979,148.328077 134.233578,143.766221 132.408743,143.766221 C130.584139,143.766221 126.799149,144.121114 126.799149,144.121114 Z",
    id: "Stroke-63",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-68",
    transform: "translate(136.247582, 82.526112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47808124,0.213330754 C8.47808124,0.213330754 11.8234584,1.12574855 22.7717756,8.27259574 C33.7200928,15.4194429 53.1331683,21.704472 63.5745609,2.24079691 C66.5144449,1.83530368 71.4815629,6.90408511 71.4815629,6.90408511 C71.4815629,6.90408511 57.3907311,30.0171992 42.1848511,32.9568511 C26.9787389,35.896735 2.33672727,30.2198298 0.364038685,10.3506615 C-0.898862669,1.73387234 5.68535397,-0.465818182 8.93440619,0.213330754",
    id: "Fill-65",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47808124,0.213330754 C8.47808124,0.213330754 11.8234584,1.12574855 22.7717756,8.27259574 C33.7200928,15.4194429 53.1331683,21.704472 63.5745609,2.24079691 C66.5144449,1.83530368 71.4815629,6.90408511 71.4815629,6.90408511 C71.4815629,6.90408511 57.3907311,30.0171992 42.1848511,32.9568511 C26.9787389,35.896735 2.33672727,30.2198298 0.364038685,10.3506615 C-0.898862669,1.73387234 5.68535397,-0.465818182 8.93440619,0.213330754",
    id: "Stroke-67",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-72",
    transform: "translate(75.203095, 62.100580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8538646,0.110762089 C11.8538646,0.110762089 12.956147,0.756951644 14.0205957,1.82140039 C16.4154894,4.216294 13.3744062,8.47408897 11.5115048,9.57660348 C9.64883559,10.6788859 8.81254932,14.9366809 8.81254932,14.9366809 C8.81254932,14.9366809 5.84736557,16.4572224 2.12179497,13.606236 C1.20960928,8.77815087 -0.501029014,2.96198066 0.411156673,0.870916828",
    id: "Fill-69",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8538646,0.110762089 C11.8538646,0.110762089 12.956147,0.756951644 14.0205957,1.82140039 C16.4154894,4.216294 13.3744062,8.47408897 11.5115048,9.57660348 C9.64883559,10.6788859 8.81254932,14.9366809 8.81254932,14.9366809 C8.81254932,14.9366809 5.84736557,16.4572224 2.12179497,13.606236 C1.20960928,8.77815087 -0.501029014,2.96198066 0.411156673,0.870916828",
    id: "Stroke-71",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.6038143,55.2926576 L84.6619961,70.3465068 C81.8397911,71.1598143 79.7691528,70.6190019 78.9219574,67.8754816 L85.6124797,54.9883636 L89.6038143,55.2926576 Z",
    id: "Fill-73",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6038143,55.2926576 L84.6619961,70.3465068 C81.8397911,71.1598143 79.7691528,70.6190019 78.9219574,67.8754816 L85.6124797,54.9883636 L89.6038143,55.2926576 Z",
    id: "Stroke-75",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-80",
    transform: "translate(56.866538, 24.731141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.196549323,30.2573153 L31.0646344,31.6258259 C31.0646344,31.6258259 35.6267234,31.2077988 36.6528743,26.645942 C37.6792573,22.0840851 34.485911,19.8412224 34.485911,19.8412224 L11.8291219,0.174916828",
    id: "Fill-77",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.196549323,30.2573153 L31.0646344,31.6258259 C31.0646344,31.6258259 35.6267234,31.2077988 36.6528743,26.645942 C37.6792573,22.0840851 34.485911,19.8412224 34.485911,19.8412224 L11.8291219,0.174916828",
    id: "Stroke-79",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.695706,24.9059652 C68.695706,24.9059652 58.8118375,20.6481702 52.7816634,36.1590406 C46.0245261,53.538383 57.0631335,54.9883636 57.0631335,54.9883636 C57.0631335,54.9883636 66.0092843,56.6358685 71.2300967,42.1901431 C76.215087,28.3968743 68.695706,24.9059652 68.695706,24.9059652",
    id: "Fill-81",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.695706,24.9059652 C68.695706,24.9059652 58.8118375,20.6481702 52.7816634,36.1590406 C46.0245261,53.538383 57.0631335,54.9883636 57.0631335,54.9883636 C57.0631335,54.9883636 66.0092843,56.6358685 71.2300967,42.1901431 C76.215087,28.3968743 68.695706,24.9059652 68.695706,24.9059652 Z",
    id: "Stroke-83",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0846963,31.0507079 L67.4792031,35.7529903 C67.4792031,35.7529903 70.6725493,37.8816557 68.0873269,42.7984062 C65.5023366,47.7149246 61.7644642,47.1068008 61.7644642,47.1068008 L48.4491064,38.501617 L51.0846963,31.0507079 Z",
    id: "Fill-85",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0846963,31.0507079 L67.4792031,35.7529903 C67.4792031,35.7529903 70.6725493,37.8816557 68.0873269,42.7984062 C65.5023366,47.7149246 61.7644642,47.1068008 61.7644642,47.1068008 L48.4491064,38.501617 L51.0846963,31.0507079 Z",
    id: "Stroke-87",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0478066,34.8015087 C52.0478066,34.8015087 51.4394507,39.312766 48.4489671,38.5015474 C45.4584836,37.690793 47.6888124,33.6864603 47.6888124,33.6864603 C47.6888124,33.6864603 48.9763172,30.2707544 51.0847892,31.0506383 C53.1932611,31.8307544 52.0478066,34.8015087 52.0478066,34.8015087",
    id: "Fill-89",
    fill: "#25383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0478066,34.8015087 C52.0478066,34.8015087 51.4394507,39.312766 48.4489671,38.5015474 C45.4584836,37.690793 47.6888124,33.6864603 47.6888124,33.6864603 C47.6888124,33.6864603 48.9763172,30.2707544 51.0847892,31.0506383 C53.1932611,31.8307544 52.0478066,34.8015087 52.0478066,34.8015087 Z",
    id: "Stroke-91",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.629385,55.2002785 C111.629385,55.2002785 107.467683,51.9361393 110.118824,48.0594662 C109.154646,44.4812843 113.210507,38.1837215 115.426677,38.129176 C117.643079,38.0748627 117.91395,40.089795 120.1654,38.7328897 C122.417083,37.3759845 122.436812,39.1848046 123.410739,39.1344371 C124.384433,39.0838375 125.260642,35.6344758 126.789308,37.2278994 C128.317973,38.8215551 129.954569,38.4754816 131.442151,38.1607427 C132.929965,37.8460039 140.935845,39.9345145 138.510545,45.3693308 C136.085478,50.804147 137.451899,53.099234 141.024743,54.3152495 C144.597818,55.531265 136.062731,62.2067002 136.356348,63.5951721 C136.650197,64.9836441 140.824201,64.8778027 137.917509,66.3217485 C135.010584,67.7654623 123.28099,69.6251141 119.779172,65.8067002 C116.277354,61.9882863 111.629385,55.2002785 111.629385,55.2002785",
    id: "Fill-93",
    fill: "#25383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.629385,55.2002785 C111.629385,55.2002785 107.467683,51.9361393 110.118824,48.0594662 C109.154646,44.4812843 113.210507,38.1837215 115.426677,38.129176 C117.643079,38.0748627 117.91395,40.089795 120.1654,38.7328897 C122.417083,37.3759845 122.436812,39.1848046 123.410739,39.1344371 C124.384433,39.0838375 125.260642,35.6344758 126.789308,37.2278994 C128.317973,38.8215551 129.954569,38.4754816 131.442151,38.1607427 C132.929965,37.8460039 140.935845,39.9345145 138.510545,45.3693308 C136.085478,50.804147 137.451899,53.099234 141.024743,54.3152495 C144.597818,55.531265 136.062731,62.2067002 136.356348,63.5951721 C136.650197,64.9836441 140.824201,64.8778027 137.917509,66.3217485 C135.010584,67.7654623 123.28099,69.6251141 119.779172,65.8067002 C116.277354,61.9882863 111.629385,55.2002785 111.629385,55.2002785 Z",
    id: "Stroke-95",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.898754,65.2525648 C116.898754,65.2525648 120.624325,70.6507079 118.191133,81.4469942 C117.050785,84.0319845 127.314847,85.4766267 130.660224,83.1956983 C134.005369,80.9147698 137.919412,78.6709787 137.919412,78.6709787 C137.919412,78.6709787 128.98742,70.5745764 127.086917,66.0127195 L125.18595,61.4510948 L116.898754,65.2525648 Z",
    id: "Fill-97",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.898754,65.2525648 C116.898754,65.2525648 120.624325,70.6507079 118.191133,81.4469942 C117.050785,84.0319845 127.314847,85.4766267 130.660224,83.1956983 C134.005369,80.9147698 137.919412,78.6709787 137.919412,78.6709787 C137.919412,78.6709787 128.98742,70.5745764 127.086917,66.0127195 L125.18595,61.4510948 L116.898754,65.2525648 Z",
    id: "Stroke-99",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.969578,74.265354 C118.969578,74.265354 121.811745,73.5086809 123.479211,70.826205 C118.672712,72.2388162 118.776232,72.3834197 118.776232,72.3834197 L118.969578,74.265354 Z",
    id: "Fill-101",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.735938,58.2584913 C127.771219,61.4516054 125.906692,62.3623985 127.408433,63.4268472 C128.440851,64.1584526 128.513269,65.7797292 128.455706,66.7246422 C124.166112,71.0012379 117.984603,75.2994197 112.540967,71.9997679 C103.03381,66.2404642 114.906615,45.9590716 114.906615,45.9590716 C115.46089,45.6350484 118.261741,46.3877756 120.821431,47.7124178 C123.381122,49.034971 125.371451,47.4225145 126.627853,46.0168665 C129.146692,47.0576402 130.806499,48.7130368 131.894159,50.5367118 C132.259033,52.4970986 132.50646,55.8311025 130.735938,58.2584913",
    id: "Fill-103",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.735938,58.2584913 C127.771219,61.4516054 125.906692,62.3623985 127.408433,63.4268472 C128.440851,64.1584526 128.513269,65.7797292 128.455706,66.7246422 C124.166112,71.0012379 117.984603,75.2994197 112.540967,71.9997679 C103.03381,66.2404642 114.906615,45.9590716 114.906615,45.9590716 C115.46089,45.6350484 118.261741,46.3877756 120.821431,47.7124178 C123.381122,49.034971 125.371451,47.4225145 126.627853,46.0168665 C129.146692,47.0576402 130.806499,48.7130368 131.894159,50.5367118 C132.259033,52.4970986 132.50646,55.8311025 130.735938,58.2584913 Z",
    id: "Stroke-105",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-109",
    fill: "#FFFFFF",
    points: "211.480155 170.022128 244.426306 170.022128 244.426306 163.432805 211.480155 163.432805"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-112",
    fill: "#FFFFFF",
    points: "211.480155 188.16766 244.426306 188.16766 244.426306 181.578337 211.480155 181.578337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.411397,184.873114 C206.411397,181.905841 204.006058,179.500503 201.038785,179.500503 C198.07128,179.500503 195.66571,181.905841 195.66571,184.873114 C195.66571,187.840387 198.07128,190.245957 201.038785,190.245957 C204.006058,190.245957 206.411397,187.840387 206.411397,184.873114",
    id: "Fill-114",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-116",
    fill: "#FFFFFF",
    points: "211.480155 206.313656 244.426306 206.313656 244.426306 199.724333 211.480155 199.724333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.411397,203.019041 C206.411397,200.051768 204.006058,197.646429 201.038785,197.646429 C198.07128,197.646429 195.66571,200.051768 195.66571,203.019041 C195.66571,205.986313 198.07128,208.391652 201.038785,208.391652 C204.006058,208.391652 206.411397,205.986313 206.411397,203.019041",
    id: "Fill-118",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-120",
    fill: "#FFFFFF",
    points: "0.348162476 179.269323 70.827853 179.269323 70.827853 143.258182 0.348162476 143.258182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.039304,85.2551257 C200.039304,85.2551257 198.495087,87.5165571 201.032031,89.5296325 C203.569207,91.5427079 206.271876,90.6049903 206.657872,89.8880077 C207.044101,89.1710251 204.534313,86.9648356 203.900193,86.6890909 C203.265841,86.4133462 200.590793,84.7862669 200.039304,85.2551257",
    id: "Fill-125",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.508046,86.6891373 C200.508046,86.6891373 202.888781,82.321323 202.128395,79.7741663 C201.368008,77.2272418 203.218143,75.9729284 205.14441,76.0868936 C207.070213,76.2008588 207.247776,78.7099497 207.729168,79.4701044 C207.729168,79.4701044 211.100077,74.4521547 215.965996,74.9084797 C220.831915,75.3645725 220.907814,78.1777253 219.767466,80.9147466 C218.627118,83.6517679 212.77265,86.5410522 208.933114,87.6433346 C205.093578,88.7458491 205.416905,89.9983056 205.416905,89.9983056 C203.47764,90.1508008 200.195629,88.7878607 200.508046,86.6891373",
    id: "Fill-126",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.508046,86.6891373 C200.508046,86.6891373 202.888781,82.321323 202.128395,79.7741663 C201.368008,77.2272418 203.218143,75.9729284 205.14441,76.0868936 C207.070213,76.2008588 207.247776,78.7099497 207.729168,79.4701044 C207.729168,79.4701044 211.100077,74.4521547 215.965996,74.9084797 C220.831915,75.3645725 220.907814,78.1777253 219.767466,80.9147466 C218.627118,83.6517679 212.77265,86.5410522 208.933114,87.6433346 C205.093578,88.7458491 205.416905,89.9983056 205.416905,89.9983056 C203.47764,90.1508008 200.195629,88.7878607 200.508046,86.6891373 Z",
    id: "Stroke-127",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.159304,149.758236 C149.159304,149.758236 149.572921,158.527752 158.838917,160.59607",
    id: "Stroke-128",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.339745,268.332603 C104.339745,268.332603 109.098662,271.67241 118.622066,268.33771 L118.558004,266.52007 C118.558004,266.52007 109.727211,268.595814 103.50694,265.641308 C104.456727,268.17477 104.339745,268.332603 104.339745,268.332603",
    id: "Fill-129",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.540503,266.988232 C185.253308,263.650747 183.959072,256.435195 183.959072,256.435195 L182.877679,255.275814 C182.877679,255.275814 183.814468,263.028928 177.324952,266.153338 L178.540503,266.988232 Z",
    id: "Fill-130",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.05918,285.104472 C184.05918,285.104472 189.542507,279.575188 194.639141,264.415961",
    id: "Stroke-131",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7596518,288.747482 C95.7596518,288.747482 99.0237911,292.718391 105.807853,291.353594 C112.592147,289.988565 123.098762,285.222917 123.098762,285.222917",
    id: "Stroke-132",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.66253,280.705973 C108.66253,280.991466 108.241021,281.22311 107.720402,281.22311 C107.200248,281.22311 106.778739,280.991466 106.778739,280.705973 C106.778739,280.42048 107.200248,280.188836 107.720402,280.188836 C108.241021,280.188836 108.66253,280.42048 108.66253,280.705973",
    id: "Fill-133",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.498012,282.236449 C105.498012,282.521942 105.076503,282.753818 104.556116,282.753818 C104.035729,282.753818 103.614221,282.521942 103.614221,282.236449 C103.614221,281.950956 104.035729,281.719311 104.556116,281.719311 C105.076503,281.719311 105.498012,281.950956 105.498012,282.236449",
    id: "Fill-134",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.705911,283.717253 C102.705911,284.002747 102.28417,284.234391 101.763783,284.234391 C101.243629,284.234391 100.821888,284.002747 100.821888,283.717253 C100.821888,283.43176 101.243629,283.200116 101.763783,283.200116 C102.28417,283.200116 102.705911,283.43176 102.705911,283.717253",
    id: "Fill-135",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.927861,282.211729 C110.927861,282.497222 110.506352,282.728867 109.985733,282.728867 C109.465578,282.728867 109.04407,282.497222 109.04407,282.211729 C109.04407,281.926236 109.465578,281.69436 109.985733,281.69436 C110.506352,281.69436 110.927861,281.926236 110.927861,282.211729",
    id: "Fill-136",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.763342,283.742205 C107.763342,284.027698 107.341834,284.259342 106.821447,284.259342 C106.30106,284.259342 105.879551,284.027698 105.879551,283.742205 C105.879551,283.456712 106.30106,283.225068 106.821447,283.225068 C107.341834,283.225068 107.763342,283.456712 107.763342,283.742205",
    id: "Fill-137",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.971242,285.22301 C104.971242,285.508503 104.549501,285.740147 104.029114,285.740147 C103.508959,285.740147 103.087219,285.508503 103.087219,285.22301 C103.087219,284.937516 103.508959,284.705872 104.029114,284.705872 C104.549501,284.705872 104.971242,284.937516 104.971242,285.22301",
    id: "Fill-138",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.271644,271.063497 C185.271644,271.486166 185.000309,271.828758 184.665609,271.828758 C184.330677,271.828758 184.05911,271.486166 184.05911,271.063497 C184.05911,270.64106 184.330677,270.298236 184.665609,270.298236 C185.000309,270.298236 185.271644,270.64106 185.271644,271.063497",
    id: "Fill-139",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.382414,273.995002 C184.382414,274.417671 184.110847,274.760263 183.776147,274.760263 C183.441215,274.760263 183.16988,274.417671 183.16988,273.995002 C183.16988,273.572333 183.441215,273.229741 183.776147,273.229741 C184.110847,273.229741 184.382414,273.572333 184.382414,273.995002",
    id: "Fill-140",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.776077,276.926507 C183.776077,277.348944 183.504743,277.691768 183.170043,277.691768 C182.83511,277.691768 182.563544,277.348944 182.563544,276.926507 C182.563544,276.503838 182.83511,276.161246 183.170043,276.161246 C183.504743,276.161246 183.776077,276.503838 183.776077,276.926507",
    id: "Fill-141",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-144",
    transform: "translate(75.435203, 57.226306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.179094778,5.74528433 C1.09151257,3.65445261 7.09801161,-0.260982592 9.34087427,0.271241779 C11.5837369,0.803466151 8.54242166,6.73360155 7.13607737,8.06427853 C5.72926886,9.3947234 2.72625145,10.21894 2.72625145,10.21894",
    id: "Fill-142",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.179094778,5.74528433 C1.09151257,3.65445261 7.09801161,-0.260982592 9.34087427,0.271241779 C11.5837369,0.803466151 8.54242166,6.73360155 7.13607737,8.06427853 C5.72926886,9.3947234 2.72625145,10.21894 2.72625145,10.21894",
    id: "Stroke-143",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.2890522,222.148503 C68.2890522,216.734112 63.8998839,212.344944 58.4854932,212.344944 C53.0711025,212.344944 48.6817021,216.734112 48.6817021,222.148503 C48.6817021,227.562894 53.0711025,231.952062 58.4854932,231.952062 C63.8998839,231.952062 68.2890522,227.562894 68.2890522,222.148503",
    id: "Fill-145",
    fill: "#FFA076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.684712,155.177199 C145.684712,155.177199 133.401772,215.245439 182.563706,263.413485",
    id: "Stroke-146",
    stroke: "#1A1A1A",
    strokeWidth: 0.696324952,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 2.785299917254272
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.368464,275.34889 C118.368464,275.34889 102.333261,234.842507 126.159876,179.98301",
    id: "Stroke-147",
    stroke: "#1A1A1A",
    strokeWidth: 0.696324952,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 2.785299917254272
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-148",
    fill: "#FFFFFF",
    points: "28.8675899 54.9884565 46.0758685 50.9927118 46.8615551 53.2102747 31.3082089 60.1185145"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-149",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "28.8675899 54.9884565 46.0758685 50.9927118 46.8615551 53.2102747 31.3082089 60.1185145"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-150",
    fill: "#FFFFFF",
    points: "48.8266306 1.3086499 55.8105377 17.5355745 58.0624526 16.8538723 54.4046576 0.232827853"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-151",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "48.8266306 1.3086499 55.8105377 17.5355745 58.0624526 16.8538723 54.4046576 0.232827853"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-152",
    fill: "#FFFFFF",
    points: "44.0085725 29.7928201 43.4283017 32.2791644 25.2272959 32.2791644 26.3855164 24.9060116"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-153",
    stroke: "#1A1A1A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "44.0085725 29.7928201 43.4283017 32.2791644 25.2272959 32.2791644 26.3855164 24.9060116"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsEmpty);
export default __webpack_public_path__ + "static/media/notifications_empty.8181a29c.svg";
export { ForwardRef as ReactComponent };